// @flow

export const SKILLS_REQUEST = 'SKILLS_REQUEST';
export const FILTER_FACILITY_REQUEST = 'FILTER_FACILITY_REQUEST';
export const FILTER_FACILITIES_ERROR = 'FILTER_FACILITIES_ERROR';
export const FILTER_FACILITY_REQUESTED = 'FILTER_FACILITY_REQUESTED';

export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const CREATE_APPOINTMENT_SUCCESS = 'CREATE_APPOINTMENT_SUCCESS';
export const CREATE_APPOINTMENT_ERROR = 'CREATE_APPOINTMENT_ERROR';

export const RESET_CREATE_APPOINTMENT = 'RESET_CREATE_APPOINTMENT';
export const UPCOMING_APPOINTMENT_REQUEST = 'UPCOMING_APPOINTMENT_REQUEST';
export const UPCOMING_APPOINTMENT_REQUESTED = 'UPCOMING_APPOINTMENT_REQUESTED';
export const UPCOMING_APPOINTMENT_REQUEST_ERROR = 'UPCOMING_APPOINTMENT_REQUEST_ERROR';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const UPDATED_APPOINTMENT = 'UPDATED_APPOINTMENT';
export const UPDATE_APPOINTMENT_ERROR = 'UPDATED_APPOINTMENT_ERROR';

export const SKILLS_REQUESTED = 'SKILLS_REQUESTED';
export const SKILLS_REQUESTED_ERROR = 'SKILLS_REQUESTED_ERROR';

export const SKILL_CREATE = 'SKILL_CREATE';
export const SKILL_CREATED = 'SKILL_CREATED';
export const SKILL_CREATED_ERROR = 'SKILL_CREATED_ERROR';

export const SKILL_UPDATE = 'SKILL_UPDATE';
export const SKILL_UPDATED = 'SKILL_UPDATED';
export const SKILL_UPDATED_ERROR = 'SKILL_UPDATED_ERROR';

export const SKILL_DELETE = 'SKILL_DELETE';
export const SKILL_DELETED = 'SKILL_DELETED';
export const SKILL_DELETED_ERROR = 'SKILL_DELETED_ERROR';

export const SKILL_RESET = 'SKILL_RESET';
